import { gql } from "@apollo/client";

export const targetSelfRating = gql`
  mutation targetSelfRating($input: TargetCompletionApprovalInput!) {
    targetCompletionApproval(input: $input) {
      id
      userTargetStatus
    }
  }
`;

export const rateUsers = gql`
  mutation rateUsers($input: RateUsersInput) {
    rateUsers(input: $input) {
      id
      userTargetStatus
    }
  }
`;

export const updateOrangeDotStatus = gql`
  mutation deleteUserTargetReadRecords($input: DeleteUserTargetRecordsInput) {
    deleteUserTargetReadRecords(input: $input) {
      targetid
    }
  }
`;


// mutation MyMutation {
//   deleteUserTargetReadRecords(input: {targetid: "eea73013-438c-4c3d-988b-1b7ef2a79895", userid: "248db55b-cbb8-4be1-b223-99067adc8eb1"}) {
//     targetid
//   }
// }
